<div class="row resourcesPage">
  <div class="col-12 resourcesPage--banner">
    <div class="container-xl">
      <div class="row">
        <div class="col-xs-12">
          <h1 class="text-center" data-aos="fade-down" data-aos-duration="1000">
            Resources
          </h1>
        </div>
        <div
          class="col-xs-12 col-md-8 pageBanner"
          data-aos="fade-right"
          data-aos-duration="1000">
          <div class="gradiunt"></div>
          <img src="./../../assets/images/posts/main-post.png" alt="" />
          <h3>
            Three Ways Artificial Intelligence Will Improve Contact Center
            Customer Service
          </h3>
          <span>Read more</span>
        </div>
        <div
          class="col-xs-12 col-md-4"
          data-aos="fade-left"
          data-aos-duration="1000">
          <div class="column bannerContent">
            <div class="col">
              <h4>Trending Posts</h4>
            </div>
            <div class="bannerContent-scroll">
              <div class="col" *ngFor="let tPost of trendingPosts">
                <img [src]="tPost.jetpack_featured_media_url" alt="" />
                <div
                  [innerHTML]="tPost.title.rendered"
                  [title]="tPost.title.rendered"
                  class="ellipsis-twoline"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="resourcesPage--tabs">
    <div class="container-xl">
      <div class="nav-pills-cont">
        <button (click)="scrollLeft()" class="arrown-btns">
          <i class="bi bi-chevron-left"></i>
        </button>
        <div #widgetsContent class="nav nav-pills">
          <div class="nav-item" *ngFor="let category of wPCategories">
            <button
              (click)="tabChange(category)"
              [ngClass]="{ active: category.id === activeCategory.id }">
              {{ getCategoryName(category) }}
            </button>
          </div>
        </div>
        <button (click)="scrollRight()" class="arrown-btns right">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
      <div
        *ngIf="activeCategory"
        id="activeCategory.id"
        class="resources--card-block">
        <div class="row">
          <div
            class="col-xs-12 col-sm-6 col-md-4"
            data-aos="fade-up"
            *ngFor="let post of wPPosts"
            data-aos-duration="1000">
            <div class="card resources--card hasBorder">
              <img
                *ngIf="post.jetpack_featured_media_url"
                [src]="post.jetpack_featured_media_url"
                class="card-img-top"
                alt="RESOURCES" />
              <div class="card-body">
                <div [innerHTML]="post.title.rendered"></div>
                <button class="flatBtn c-p f600" (click)="goToPost(post)">
                  READ MORE <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>

          <div
            class="col-xs-12 text-center smy3"
            *ngIf="currentPage < totalPages">
            <button (click)="nextPage()" type="button" class="primaryBtn">
              LOAD MORE
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-book-consultation [title]="title" class="spa0 col-12" />
</div>
